export default class Flashmessages {
    static init(): void {
        const flashmessages: NodeListOf<HTMLElement> = document.querySelectorAll('.flashmessages');

        if (flashmessages.length > 0) {
            flashmessages.forEach((message: HTMLElement) => {
                const messageButton: HTMLElement | null = message.querySelector('.close');

                if (messageButton) {
                    messageButton.addEventListener('click', () => {
                        message.style.display = 'none';
                    });
                }
            });
        }
    }
}